// extracted by mini-css-extract-plugin
module.exports = {"mfa_code_form_text":"mfaOTPcodeform_mfa_code_form_text__2W8Eh","mfa_code_form_container":"mfaOTPcodeform_mfa_code_form_container__2P2oK"};